/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Responsive_Better_On_DesktopInputs */

const cs_responsive_better_on_desktop = /** @type {(inputs: Responsive_Better_On_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento editor je pohodlnější na větším displeji. Na telefonu můžete prohlížet a dělat lehké úpravy.`)
};

const en_responsive_better_on_desktop = /** @type {(inputs: Responsive_Better_On_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This editor works best on a larger screen. You can still view and make light edits on your phone.`)
};

/**
* | output |
* | --- |
* | "This editor works best on a larger screen. You can still view and make light edits on your phone." |
*
* @param {Responsive_Better_On_DesktopInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const responsive_better_on_desktop = /** @type {((inputs?: Responsive_Better_On_DesktopInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Responsive_Better_On_DesktopInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_responsive_better_on_desktop(inputs)
	return cs_responsive_better_on_desktop(inputs)
});